"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pricingInverse = exports.metadata = exports["default"] = void 0;
var _rawPricings = _interopRequireDefault(require("./rawPricings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // *** Version: 5 ***
/* eslint max-len: 0 */
// #####################################################################
// # @README before updating price:                                    #
// # * don't change the id of an item                                  #
// # * don't delete an item, set `hidden: true`                        #
// # * update version at the top of the file and in metadata object    #
// # * @TODO: update price on tilli-site                               #
// #####################################################################

var metadata = exports.metadata = {
  minOrderAmount: 20,
  deliveryFee: 5,
  version: 5,
  mostCommonCategoryName: 'Les plus courants',
  // put positions here rather than directly reorganizing the categories and clothes
  // because it's easier to keep up with the original excel price sheet
  clothPositions: ['pant', 'haut', 'robe', 'pull', 'mant', 'jupe', 'ling', 'deco'],
  categoryPositions: ['Ourlets', 'Raccourcir', 'Cintrer', 'Rallonger', 'Élargir', 'Divers', 'Broderie main', 'Rideaux', 'Coussins']
};
function getClothPosition(clothSlug) {
  return metadata.clothPositions.findIndex(function (clothSlugIt) {
    return clothSlugIt === clothSlug;
  });
}
function sortClothes(clothes) {
  return clothes.sort(function (a, b) {
    return getClothPosition(a.slug) - getClothPosition(b.slug);
  });
}
function getCategoryPosition(categoryName) {
  return metadata.categoryPositions.findIndex(function (categoryNameIt) {
    return categoryNameIt === categoryName;
  });
}
function sortCategories(clothes) {
  return clothes.map(function (cloth) {
    cloth.categories.sort(function (a, b) {
      return getCategoryPosition(a.name) > getCategoryPosition(b.name) ? 1 : -1;
    });
    return cloth;
  });
}
function getMostCommonCategory(cloth) {
  var items = [];
  cloth.categories.forEach(function (cat) {
    return cat.items.forEach(function (item) {
      if (typeof item.mostCommonCategoryPosition === 'number') items.push(item);
    });
  });
  return {
    name: metadata.mostCommonCategoryName,
    mostCommonCategory: true,
    items: items.sort(function (a, b) {
      return a.mostCommonCategoryPosition > b.mostCommonCategoryPosition ? 1 : -1;
    })
  };
}
function addMostCommonCategory(clothes) {
  return clothes.map(function (cloth) {
    if (!cloth.hasMostCommonCategory) return cloth;
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: [getMostCommonCategory(cloth)].concat(_toConsumableArray(cloth.categories))
    });
  });
}
var sortedClothes = sortClothes(_rawPricings["default"]);
var sortedClothesAndCategories = sortCategories(sortedClothes);
var pricing = addMostCommonCategory(sortedClothesAndCategories);
var _default = exports["default"] = pricing;
var pricingInverse = exports.pricingInverse = {};
pricing.forEach(function (cloth) {
  return cloth.categories.filter(function (cat) {
    return cat.name !== metadata.mostCommonCategoryName;
  }).forEach(function (category) {
    return category.items.forEach(function (item) {
      if (pricingInverse[item.id]) {
        throw new Error("Inverse pricing, duplicate key : ".concat(item.id));
      }
      pricingInverse[item.id] = _objectSpread(_objectSpread({}, item), {}, {
        cloth: cloth.name,
        category: category.name
      });
    });
  });
});